"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const generic_browser_lib_1 = require("@squiz/generic-browser-lib");
function SourceList({ sources, onSourceSelect }) {
    return (react_1.default.createElement("div", { className: "overflow-y-scroll w-screen max-w-[400px] flex-1 grow-[3] border-r border-gray-300 bg-gray-100 pl-4.5 pr-4.5 pb-4.5 pt-3" },
        react_1.default.createElement("div", { className: "text-md font-semibold" }, "Select an environment to use"),
        react_1.default.createElement("ul", { tabIndex: -1, "aria-label": `environment list`, className: "flex flex-col bg-gray-100 min-h-full focus-visible:outline-0" }, sources.map((source, index) => {
            return (react_1.default.createElement("li", { key: index, className: "flex items-stretch relative" },
                react_1.default.createElement("button", { onClick: () => {
                        onSourceSelect(source);
                    }, className: "w-full p-1 mt-3 bg-white border-1 border-grey-200 min-h-[64px] rounded-lg flex items-center text-md font-semibold" },
                    react_1.default.createElement(generic_browser_lib_1.Icon, { icon: source.type, className: "ml-4" }),
                    react_1.default.createElement("span", { className: "line-clamp-2 text-left break-word ml-4" }, source.name || source.id),
                    react_1.default.createElement(generic_browser_lib_1.Icon, { icon: 'arrow-right', className: "absolute ml-1 right-4" }))));
        }))));
}
exports.default = SourceList;
